import React from "react"
import { createUseStyles, useTheme } from "react-jss"

import Select, { OptionProps, components } from "react-select"
import { IDropDownOptions } from "../../util/interface"
import { timePeriodMapper } from "../../util/StaticData"

const useStyles: any = createUseStyles({
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    // paddingRight: "20px",
  },
  filterLabel: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
    maxWidth: (props: any) => {
      return props["maxWidth"]
    },
  },
  filterValue: {
    borderRadius: "6px",
    border: "1px solid #E6ECF0",
    background: "#FFF",
    height: 26,
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  item: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
  },
})
//

const SingleSelection = ({
  showLabel = true,
  label = "",
  options,
  filterValue,
  changeFunc,
  maxWidth,
  minWidth,
  minHeight,
  isSearchable = false,
  isDisabled = false,
  maxMenuHeight,
  removeMarginRight = false,
}: {
  label?: string
  options: IDropDownOptions[]
  filterValue: string | boolean
  changeFunc: any
  maxWidth: number
  minWidth: number
  minHeight?: number
  showLabel?: boolean
  isSearchable?: boolean
  isDisabled?: boolean
  maxMenuHeight?: number
  removeMarginRight?: boolean
}) => {
  const theme: any = useTheme()
  const classes = useStyles({ maxWidth, theme })

  const colourStyles: any = {
    control: (styles: any) => ({
      ...styles,
      backgroundColor: "white",
      minWidth: minWidth,
      height: 26,
      minHeight: minHeight ? minHeight : 26,
      maxHeight: 26,
      display: "flex",
      alignContent: "center",
    }),
    option: (styles: any, { isDisabled, isSelected }: any) => {
      const backgroundColor = isDisabled
        ? undefined
        : isSelected
        ? "var(--primary-dp-color-80)"
        : "white"
      const color = isDisabled
        ? "rgb(204, 204, 204)"
        : isSelected
        ? "black"
        : "black"
      const fontWeight = isDisabled
        ? "rgb(204, 204, 204)"
        : isSelected
        ? "600"
        : "400"
      const cursor = isDisabled ? "not-allowed" : "default"
      return {
        ...styles,
        backgroundColor,
        color,
        cursor,
        fontWeight,
        ":active": {
          ...styles[":active"],
          backgroundColor: "var(--primary-dp-color-40)",
        },
        whiteSpace: "nowrap", // Prevent text from wrapping
        overflow: "hidden",
        textOverflow: "ellipsis", // Show ellipsis for overflowing text
      }
    },
    menu: (styles: any) => ({ ...styles, zIndex: 100 }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: "30px",
      padding: 0,
    }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      // paddingTop: 7,
      // paddingBottom: 7,
      padding: 3,
    }),
    clearIndicator: (styles: any) => ({
      ...styles,
      // paddingTop: 7,
      // paddingBottom: 7,
      padding: 0,
    }),
  }

  const getOptionLabel = (option: any) => {
    return option.label
  }

  return (
    <>
      <div className={classes.filterWrapper}>
        {showLabel ? <div className={classes.filterLabel}>{label}:</div> : ""}
        <Select
          // className="basic-single"
          // classNamePrefix="select"
          // defaultValue={options ? options[0] : ''}
          classNamePrefix="mySelect"
          isDisabled={isDisabled}
          isLoading={false}
          isClearable={false}
          isRtl={false}
          isSearchable={isSearchable}
          name="color"
          options={options}
          maxMenuHeight={maxMenuHeight ? maxMenuHeight : undefined}
          // value={}
          value={{ value: filterValue, label: filterValue }}
          styles={colourStyles}
          onChange={(obj: any) => {
            if (obj.value != filterValue) {
              changeFunc(obj["value"])
            }
          }}
          className={
            removeMarginRight
              ? { ...classes.filterValue, marginRight: 0 }
              : classes.filterValue
          }
          components={{
            IndicatorSeparator: () => null,
            SingleValue,
            Option,
          }}
          getOptionLabel={getOptionLabel}
        />
      </div>
    </>
  )
}

export default React.memo(SingleSelection)
const SingleValue = ({ children, ...props }: any) => {
  return (
    <components.SingleValue {...props}>
      <div
        title={
          timePeriodMapper[children] ? timePeriodMapper[children] : children
        }
      >
        {timePeriodMapper[children] ? timePeriodMapper[children] : children}
      </div>
    </components.SingleValue>
  )
}
const Option = (props: OptionProps<any>) => {
  return (
    <div title={props.data.label}>
      <components.Option {...props} />
    </div>
  )
}
